webpackJsonp([83],{

/***/ "Q247":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-vertical-text-video_a5686fa69f8eabc23422283a4cef14eb.html";

/***/ }),

/***/ "oprM":
/***/ (function(module, exports, __webpack_require__) {

var SectionVerticalTextVideo = (function () {
    function SectionVerticalTextVideo() {
        this.bgStyle = this.bgStyle || 'gradient-wave';
    }
    return SectionVerticalTextVideo;
}());
angular.module('animatronApp.sectionVerticalTextVideo', []).component('sectionVerticalTextVideo', {
    bindings: {
        ltTitle: '<',
        description: '<',
        isDuration: '<?',
        buttons: '<',
        video: '<',
        isPlayBtn: '<',
        bgStyle: '@',
    },
    controller: SectionVerticalTextVideo,
    templateUrl: __webpack_require__("Q247")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/83-257c10c0995a4d25fa59.min.js